import { createSlice } from "@reduxjs/toolkit"

var data = []

if (localStorage.getItem("user") !== null && localStorage.getItem("user") !== undefined && localStorage.getItem("user") !== "") {
    data = JSON.parse(localStorage.getItem("user"))
}

const Insider = createSlice({
    name: "admin",
    initialState: data,
    reducers: {
        getadmin: (state, action) => {
            // Return the new state directly instead of mutating
            return action.payload
        },
    },
})

export const { getadmin } = Insider.actions;
export default Insider.reducer;